<template>
  <div
    class="
      user-select-item
      d-flex
      align-center
      flex-nowrap
    "
  >
    <div>
      <v-avatar
        size="32"
        rounded="circle"
        color="var(--gray-200)"
      >
        <v-img
          v-if="showImage"
          width="32"
          :src="profilePicture"
          @error="imgErrorHandler"
        />
        <StIcon
          v-else
          icon-name="account"
          color="var(--gray-300)"
        />
      </v-avatar>
    </div>
    <div class="user-select-item__channel d-flex justify-center">
      <component
        :is="getChannelComponent(channel)"
        :channel="channel"
      />
    </div>
    <div class="user-select-item__text">
      <div class="body-1 text-truncate">
        {{ name }}
      </div>
      <div class="caption grey--text text-truncate">
        {{ usernameLabel }}
      </div>
    </div>
    <div
      class="d-flex"
      @click.stop
    >
      <v-btn
        icon
        :color="considerButtonColor"
        @click.stop="filterUser"
      >
        <StIcon icon-name="check-circle-outline" />
      </v-btn>

      <v-btn
        icon
        :color="ignoreButtonColor"
        @click.stop="ignoreUser"
      >
        <StIcon icon-name="cancel" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import { findSocialIcon } from '@/utils/channels';
import colors from '@/utils/colors';
import StIcon from '@stilingue/st-icon';

export default {
  name: 'UserSelectItem',
  components: {
    StIcon,
  },
  props: {
    uid: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      required: true,
    },
    channel: {
      type: String,
      required: true,
    },
    profilePicture: {
      type: String,
      default: null,
    },
    /*
      The property shouldIgnore represents the type of filter:
        - null - not selected (used only in search for new users to select)
        - true - selected to filter by in filter
        - false - selected to be ignored in filter
    */
    shouldIgnore: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      errorToLoadImage: false,
    };
  },
  computed: {
    showImage() {
      return this.profilePicture && !this.errorToLoadImage;
    },
    usernameLabel() {
      if (!this.username) {
        return false;
      }

      return `@${this.username}`;
    },
    considerButtonColor() {
      if (this.shouldIgnore) {
        return colors.ui.steel;
      }

      if (this.shouldIgnore === false) {
        return colors.positiveColor;
      }

      return null;
    },
    ignoreButtonColor() {
      if (this.shouldIgnore) {
        return colors.negativeColor;
      }

      if (this.shouldIgnore === false) {
        return colors.ui.steel;
      }

      return null;
    },
  },
  methods: {
    getChannelComponent(channel) {
      return findSocialIcon(channel);
    },
    imgErrorHandler() {
      this.errorToLoadImage = true;
    },
    filterUser() {
      this.$emit('filter-user', {
        uid: this.uid,
      });
    },
    ignoreUser() {
      this.$emit('ignore-user', {
        uid: this.uid,
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .user-select-item {
    &__channel {
      width: 68px;
    }

    &__text {
      width: 88px;
    }
  }
</style>
